const TOOLS = {
    JOB_DESCRIPTION_BUILDER_SEARCH: {
        SECTION_NAME: 'Job Description Builder',
        PARENT_ID: 'jobDescriptionBuilder',
        RESOURCE_ID: 'jobDescriptionBuilder',
    },
    JOB_DESCRIPTION_LIBRARY: {
        SECTION_NAME: 'Job Description Library',
        RESOURCE_ID: 'jobDescriptionLibrary',
    },
    BENEFITS_DOCUMENT_CREATOR: {
        RESOURCE_ID: 'benefitsDocumentCreator',
    },
    BENEFITS_COMPLIANCE_SUITE: {
        RESOURCE_ID: 'benefitsComplianceSuite',
    },
    SALARY_COMPARE: {
        RESOURCE_ID: 'salaryCompare',
    },
    CALCULATORS: {
        RESOURCE_ID: 'calculators',
    },
    MINIMUN_WAGE_MAP: {
        RESOURCE_ID: 'minimumWageMap',
    },
    ACA_REPORTING_HUB: {
        RESOURCE_ID: 'acaReportingHub',
    },
};

export default TOOLS;
